import React from "react";

const EditToApprove = ({
  id,
  closeEditToApprove,
  editToApprove,
  setIsModalOpen,
  handleOpenViewSelfiePhoto,
  handleOpenSeeIdentityDoc,
  customerEditDetails,
  setCustomerEditDetails,
  handleOpenApprovalNote,
}) => {
  const handleBackButtonClick = () => {
    // Close the current modal
    closeEditToApprove();

    // Open the next modal
    setIsModalOpen(true);
  };

  const handleContinueButtonClick = () => {
    closeEditToApprove();

    handleOpenApprovalNote();
  };

  const formatDate = (date) => {
    return new Date(date).toISOString().split("T")[0];
  };

  return (
    <>
      <div
        id={id}
        className={`${
          editToApprove ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex fixed min-h-[80%] w-[60%]">
          <div className="relative flex bg-white shadow w-full mx-auto">
            <div className="flex flex-col justify-between w-full px-5">
              <div>
                <div className="flex items-center justify-end">
                  <button
                    onClick={closeEditToApprove}
                    type="button"
                    className="bg-transparent  rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    data-modal-toggle={id}
                  >
                    <svg
                      width="61"
                      height="43"
                      viewBox="0 0 61 43"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_13891_3896)">
                        <path
                          d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_13891_3896">
                          <rect width="61" height="43" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="sr-only">Close modal</span>
                  </button>
                </div>
                <div className="mt-3 mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Manual Review Uploaded KYC Document
                  </p>
                  <div className="text-[#000] mt-3 text-sm font-normal">
                    <p>
                      Please carefully review the uploaded ID and compare it
                      with the user's details below. Ensure that all
                      <br />
                      information on the ID, including name, date of birth, and
                      ID number, matches the records on file.
                    </p>
                  </div>
                </div>
                <div className="flex justify-between w-full mt-8">
                  <div className="flex w-[48%] flex-col justify-center">
                    <div className="flex items-center border border-[#000000] px-3 w-full h-[65px]">
                      <svg
                        width="45"
                        height="37"
                        viewBox="0 0 45 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M41.4062 0.0234375H3.59375C2.79603 0.0234375 2.03098 0.340331 1.46691 0.904406C0.902831 1.46848 0.585938 2.23353 0.585938 3.03125V33.9688C0.585938 34.7665 0.902831 35.5315 1.46691 36.0956C2.03098 36.6597 2.79603 36.9766 3.59375 36.9766H41.4062C42.204 36.9766 42.969 36.6597 43.5331 36.0956C44.0972 35.5315 44.4141 34.7665 44.4141 33.9688V3.03125C44.4141 2.23353 44.0972 1.46848 43.5331 0.904406C42.969 0.340331 42.204 0.0234375 41.4062 0.0234375ZM3.59375 2.60156H41.4062C41.5202 2.60156 41.6295 2.64683 41.7101 2.72741C41.7907 2.808 41.8359 2.91729 41.8359 3.03125V26.142L35.5045 19.8105C35.2252 19.5312 34.8936 19.3096 34.5287 19.1585C34.1637 19.0073 33.7726 18.9295 33.3775 18.9295C32.9825 18.9295 32.5914 19.0073 32.2264 19.1585C31.8615 19.3096 31.5299 19.5312 31.2506 19.8105L26.6486 24.4125L16.8926 14.6543C16.6133 14.375 16.2817 14.1534 15.9167 14.0022C15.5518 13.851 15.1606 13.7732 14.7656 13.7732C14.3706 13.7732 13.9795 13.851 13.6145 14.0022C13.2496 14.1534 12.918 14.375 12.6387 14.6543L3.16406 24.1289V3.03125C3.16406 2.91729 3.20933 2.808 3.28991 2.72741C3.3705 2.64683 3.47979 2.60156 3.59375 2.60156ZM3.16406 33.9688V27.7748L14.4605 16.4783C14.5005 16.438 14.548 16.4061 14.6004 16.3843C14.6527 16.3624 14.7089 16.3512 14.7656 16.3512C14.8223 16.3512 14.8785 16.3624 14.9309 16.3843C14.9832 16.4061 15.0308 16.438 15.0707 16.4783L32.9908 34.3984H3.59375C3.47979 34.3984 3.3705 34.3532 3.28991 34.2726C3.20933 34.192 3.16406 34.0827 3.16406 33.9688ZM41.4062 34.3984H36.6367L28.4727 26.2344L33.0725 21.6324C33.1124 21.5925 33.1598 21.5608 33.2119 21.5392C33.2641 21.5175 33.32 21.5064 33.3765 21.5064C33.4329 21.5064 33.4888 21.5175 33.541 21.5392C33.5932 21.5608 33.6406 21.5925 33.6805 21.6324L41.8445 29.7965V33.9688C41.8445 34.0259 41.8331 34.0825 41.811 34.1352C41.7889 34.1879 41.7565 34.2356 41.7157 34.2757C41.6748 34.3157 41.6264 34.3471 41.5733 34.3682C41.5202 34.3893 41.4634 34.3996 41.4062 34.3984ZM26.3672 12.4844C26.3672 12.0595 26.4932 11.6441 26.7293 11.2908C26.9653 10.9375 27.3009 10.6621 27.6935 10.4995C28.086 10.3369 28.518 10.2943 28.9348 10.3772C29.3515 10.4601 29.7343 10.6647 30.0348 10.9652C30.3353 11.2657 30.5399 11.6485 30.6228 12.0652C30.7057 12.482 30.6631 12.914 30.5005 13.3065C30.3379 13.6991 30.0625 14.0347 29.7092 14.2707C29.3559 14.5068 28.9405 14.6328 28.5156 14.6328C27.9458 14.6328 27.3994 14.4065 26.9964 14.0035C26.5935 13.6006 26.3672 13.0542 26.3672 12.4844Z"
                          fill="black"
                        />
                      </svg>
                      <div className="text-[#000000] text-[16px] font-normal ml-3">
                        ID Photo{" "}
                        <span
                          className="text-[#06B217] font-normal cursor-pointer"
                          onClick={handleOpenSeeIdentityDoc}
                        >
                          (OPEN)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex w-[48%] flex-col justify-center">
                    <div className="flex items-center text-[#000000] border border-[#000000] px-3 w-full h-[65px] text-[16px] font-[300]">
                      <svg
                        width="45"
                        height="37"
                        viewBox="0 0 45 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M41.4062 0.0234375H3.59375C2.79603 0.0234375 2.03098 0.340331 1.46691 0.904406C0.902831 1.46848 0.585938 2.23353 0.585938 3.03125V33.9688C0.585938 34.7665 0.902831 35.5315 1.46691 36.0956C2.03098 36.6597 2.79603 36.9766 3.59375 36.9766H41.4062C42.204 36.9766 42.969 36.6597 43.5331 36.0956C44.0972 35.5315 44.4141 34.7665 44.4141 33.9688V3.03125C44.4141 2.23353 44.0972 1.46848 43.5331 0.904406C42.969 0.340331 42.204 0.0234375 41.4062 0.0234375ZM3.59375 2.60156H41.4062C41.5202 2.60156 41.6295 2.64683 41.7101 2.72741C41.7907 2.808 41.8359 2.91729 41.8359 3.03125V26.142L35.5045 19.8105C35.2252 19.5312 34.8936 19.3096 34.5287 19.1585C34.1637 19.0073 33.7726 18.9295 33.3775 18.9295C32.9825 18.9295 32.5914 19.0073 32.2264 19.1585C31.8615 19.3096 31.5299 19.5312 31.2506 19.8105L26.6486 24.4125L16.8926 14.6543C16.6133 14.375 16.2817 14.1534 15.9167 14.0022C15.5518 13.851 15.1606 13.7732 14.7656 13.7732C14.3706 13.7732 13.9795 13.851 13.6145 14.0022C13.2496 14.1534 12.918 14.375 12.6387 14.6543L3.16406 24.1289V3.03125C3.16406 2.91729 3.20933 2.808 3.28991 2.72741C3.3705 2.64683 3.47979 2.60156 3.59375 2.60156ZM3.16406 33.9688V27.7748L14.4605 16.4783C14.5005 16.438 14.548 16.4061 14.6004 16.3843C14.6527 16.3624 14.7089 16.3512 14.7656 16.3512C14.8223 16.3512 14.8785 16.3624 14.9309 16.3843C14.9832 16.4061 15.0308 16.438 15.0707 16.4783L32.9908 34.3984H3.59375C3.47979 34.3984 3.3705 34.3532 3.28991 34.2726C3.20933 34.192 3.16406 34.0827 3.16406 33.9688ZM41.4062 34.3984H36.6367L28.4727 26.2344L33.0725 21.6324C33.1124 21.5925 33.1598 21.5608 33.2119 21.5392C33.2641 21.5175 33.32 21.5064 33.3765 21.5064C33.4329 21.5064 33.4888 21.5175 33.541 21.5392C33.5932 21.5608 33.6406 21.5925 33.6805 21.6324L41.8445 29.7965V33.9688C41.8445 34.0259 41.8331 34.0825 41.811 34.1352C41.7889 34.1879 41.7565 34.2356 41.7157 34.2757C41.6748 34.3157 41.6264 34.3471 41.5733 34.3682C41.5202 34.3893 41.4634 34.3996 41.4062 34.3984ZM26.3672 12.4844C26.3672 12.0595 26.4932 11.6441 26.7293 11.2908C26.9653 10.9375 27.3009 10.6621 27.6935 10.4995C28.086 10.3369 28.518 10.2943 28.9348 10.3772C29.3515 10.4601 29.7343 10.6647 30.0348 10.9652C30.3353 11.2657 30.5399 11.6485 30.6228 12.0652C30.7057 12.482 30.6631 12.914 30.5005 13.3065C30.3379 13.6991 30.0625 14.0347 29.7092 14.2707C29.3559 14.5068 28.9405 14.6328 28.5156 14.6328C27.9458 14.6328 27.3994 14.4065 26.9964 14.0035C26.5935 13.6006 26.3672 13.0542 26.3672 12.4844Z"
                          fill="black"
                        />
                      </svg>
                      <div className="text-[#000000] text-[16px] font-normal ml-3">
                        Selfie Photo{" "}
                        <span
                          className="text-[#06B217] font-normal cursor-pointer"
                          onClick={handleOpenViewSelfiePhoto}
                        >
                          (OPEN)
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between mb-[20px] mt-5">
                  <div className="flex w-[48%] flex-col">
                    <label htmlFor="firstname">Identity Document Number</label>
                    <input
                      type="text"
                      value={customerEditDetails?.identification}
                      onChange={(e) =>
                        setCustomerEditDetails((prev) => ({
                          ...prev,
                          identification: e.target.value,
                        }))
                      }
                      className="h-[40px] px-[10px] mt-[5px] border-[1px] border-[#9A9A9A] focus:outline-none"
                    />
                  </div>

                  <div className="flex w-[48%] flex-col">
                    <label htmlFor="firstname">First Name</label>
                    <input
                      type="text"
                      value={customerEditDetails?.firstname}
                      onChange={(e) =>
                        setCustomerEditDetails((prev) => ({
                          ...prev,
                          firstname: e.target.value,
                        }))
                      }
                      className="h-[40px] px-[10px] mt-[5px] border-[1px] border-[#9A9A9A] focus:outline-none"
                    />
                  </div>
                </div>
                <div className="flex justify-between mb-[20px]">
                  <div className="flex w-[48%] flex-col">
                    <label htmlFor="firstname">Middle Name</label>
                    <input
                      type="text"
                      value={customerEditDetails?.middlename}
                      onChange={(e) =>
                        setCustomerEditDetails((prev) => ({
                          ...prev,
                          middlename: e.target.value,
                        }))
                      }
                      className="h-[40px] px-[10px] mt-[5px] border-[1px] border-[#9A9A9A] focus:outline-none"
                    />
                  </div>

                  <div className="flex w-[48%] flex-col">
                    <label htmlFor="firstname">Last Name</label>
                    <input
                      type="text"
                      value={customerEditDetails?.lastname}
                      onChange={(e) =>
                        setCustomerEditDetails((prev) => ({
                          ...prev,
                          lastname: e.target.value,
                        }))
                      }
                      className="h-[40px] px-[10px] mt-[5px] border-[1px] border-[#9A9A9A] focus:outline-none"
                    />
                  </div>

                  {/* <div className="flex w-[50%] flex-col">
                    <label htmlFor="firstname">Date of Birth</label>
                    <input
                      type="date"
                      value={
                        customerEditDetails?.dob &&
                        formatDate(customerEditDetails?.dob)
                      }
                      onChange={(e) =>
                        setCustomerEditDetails((prev) => ({
                          ...prev,
                          dob: e.target.value,
                        }))
                      }
                      className="w-[95%] h-[40px] px-[10px] px-[10px] mt-[5px] border-[1px] border-[#9A9A9A] focus:outline-none"
                    />
                  </div> */}
                </div>

                <div className="flex justify-between mb-[15px]">
                  <div className="flex w-[48%] flex-col">
                    <label htmlFor="firstname">Date of Birth</label>
                    <input
                      type="date"
                      value={
                        customerEditDetails?.dob &&
                        formatDate(customerEditDetails?.dob)
                      }
                      onChange={(e) =>
                        setCustomerEditDetails((prev) => ({
                          ...prev,
                          dob: e.target.value,
                        }))
                      }
                      className="h-[40px] px-[10px] px-[10px] mt-[5px] border-[1px] border-[#9A9A9A] focus:outline-none"
                    />
                  </div>

                  <div className="flex w-[48%] flex-col">
                    <label htmlFor="gender">Gender</label>
                    <select
                      id="gender"
                      value={customerEditDetails?.gender || ""}
                      onChange={(e) =>
                        setCustomerEditDetails((prev) => ({
                          ...prev,
                          gender: e.target.value,
                        }))
                      }
                      className="h-[40px] px-[10px] mt-[5px] border-[1px] border-[#9A9A9A] focus:outline-none"
                    >
                      <option value="other">
                        {customerEditDetails?.gender}
                      </option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between mt-10 mb-8">
                <div className="flex items-center gap-[20px]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#074073] bg-[#7FB8EB] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded-[5px] text-sm px-12 py-2.5 text-center"
                  >
                    Back
                  </button>
                </div>
                <button
                  onClick={handleContinueButtonClick}
                  type="button"
                  className="text-white 
                       bg-[#074073] hover:bg-[#074073] focus:outline-none
                      
                   block font-medium rounded-[5px] text-sm px-12 py-2.5 text-center"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditToApprove;
